export default {
  regionPostcodes (state) {
    return state.accountRegions.map(region => {
      return { postcode: region.postcode }
    })
  },

  currentPage (state) {
    return state.route.name
  }
}
